import React from 'react';
import { useLocation } from 'react-router-dom';
import { NavMenu } from './components/NavMenu';
import { Container } from 'reactstrap'

export function LayoutWithMenu({ children }) {
    const location = useLocation();

    return (
        <div>
            <NavMenu />
            <Container tag="main">{children}</Container>
        </div>
    );
}

